<template>
  <div>
    <el-input
      class="input"
      type="number"
      :disabled="disabled"
      :value="materialQuantitySelect"
      @input="handleChangeMaterialQuantitiy($event)"
    ></el-input>
  </div>
</template>

<script>
import { Input } from "element-ui";

export default {
  props: ["value", "disabled"],
  components: {
    "el-input": Input
  },
  computed: {
    materialQuantitySelect() {
      return this.value;
    },
  },
  methods: {
    handleChangeMaterialQuantitiy(value) {
      if (value) {
        this.$emit("input", +value);
      } else {
        this.$emit("input", value);
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/lib/components/materialQuantitySelector.vue